import { render, staticRenderFns } from "./RankForm.vue?vue&type=template&id=06ed3093&"
import script from "./RankForm.vue?vue&type=script&lang=js&"
export * from "./RankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports